import React, { useState, useEffect } from 'react';

/**
 * 数字だけで打てる時刻入力。
 * スマホでも時計UIではなく数字キーボードが出ます。
 *
 *   "9"    → 09:00
 *   "930"  → 09:30
 *   "1430" → 14:30
 *   ""     → 未設定
 */
const parseTime = (raw) => {
  const digits = String(raw).replace(/[^0-9]/g, '');
  if (digits === '') return null;

  let h;
  let m;
  if (digits.length <= 2) {
    h = parseInt(digits, 10);
    m = 0;
  } else {
    h = parseInt(digits.slice(0, digits.length - 2), 10);
    m = parseInt(digits.slice(-2), 10);
  }

  if (isNaN(h) || isNaN(m)) return null;
  h = Math.min(23, Math.max(0, h));
  m = Math.min(59, Math.max(0, m));
  return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
};

function TimeInput({ value, onChange, className = '', placeholder = '--:--', title }) {
  const [text, setText] = useState(value || '');

  useEffect(() => {
    setText(value || '');
  }, [value]);

  const commit = () => {
    // 全角→半角変換
    let value = text;
    value = value.replace(/[Ａ-Ｚａ-ｚ０-９]/g, (s) => 
      String.fromCharCode(s.charCodeAt(0) - 0xFEE0)
    );
    value = value.replace(/：/g, ':');
    
    const parsed = parseTime(value);
    setText(parsed || '');
    if (parsed !== (value || null)) onChange(parsed);
  };

  return (
    <input
      className={className}
      type="text"
      inputMode="numeric"
      value={text}
      placeholder={placeholder}
      title={title}
      onChange={(e) => setText(e.target.value)}
      onBlur={commit}
      onKeyDown={(e) => e.key === 'Enter' && e.target.blur()}
      onFocus={(e) => e.target.select()}
    />
  );
}

export default TimeInput;
